module.exports = __webpack_public_path__ + "img/gear.08063dd6.svg";